export default "__VITE_ASSET__3337421f__"